module.exports = __webpack_public_path__ + "img/H2M1.a88ced8d.jpg";